import { useState } from "react";

export const FadeImage = ({ src, alt, className = "", wrapperClassName = "", style, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`img-shimmer-wrap ${loaded ? "img-loaded" : ""} ${wrapperClassName}`}>
      <img
        src={src}
        alt={alt}
        className={`img-fade ${className}`}
        style={style}
        onLoad={() => setLoaded(true)}
        {...props}
      />
    </div>
  );
};

export default FadeImage;
